import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const HomepageAbout = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography
        variant="openSans14"
        dangerouslySetInnerHTML={{ __html: t('disclaimer') }}
        component="div"
        sx={{ textAlign: 'justify' }}
      />
    </Box>
  );
};

export default HomepageAbout;
